if (!customElements.get('product-notify-me')) {
  customElements.define('product-notify-me', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.form = this.querySelector('[data-notify-form]');
      this.button = this.querySelector('button');
      this.message = this.querySelector('[data-notify-message]');
      this.successfulVariants = new Set();
      this.form.addEventListener('submit', event => this.submit(event), { signal: this.controller.signal });
      document.addEventListener('variant:update', event => this.updateVariant(event), { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      this.controller = null;
    }
    updateVariant(event) {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      const variant = event.detail.resource;
      this.dataset.variantId = variant?.id ? String(variant.id) : '';
      this.hidden = !variant || variant.available;
      const label = this.querySelector('[data-notify-variant]');
      label.textContent = variant?.title || '';
      label.hidden = !variant?.title || variant.title === 'Default Title';
      this.form.hidden = this.successfulVariants.has(this.dataset.variantId);
      this.message.textContent = this.form.hidden ? this.dataset.success : '';
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.hidden || !this.dataset.variantId || !this.form.reportValidity()) return;
      const variantId = this.dataset.variantId;
      const email = this.form.elements.email.value.trim();
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.pending;
      this.message.textContent = '';
      this.request = new AbortController();
      const timeout = setTimeout(() => this.request.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.dataset.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
          signal: this.request.signal,
          body: JSON.stringify({ data: {
            type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
          } })
        });
        if (!response.ok) throw new Error('Subscription not accepted');
        this.successfulVariants.add(variantId);
        if (this.dataset.variantId === variantId) {
          this.form.hidden = true;
          this.message.textContent = this.dataset.success;
        }
      } catch (error) {
        if (this.isConnected && this.dataset.variantId === variantId) this.message.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = this.dataset.label;
      }
    }
  });
}
